const dataKompetisi = [
  {
    id: "IoT",
    name: "iot",
    title: "Internet of Things Development Competition",
    content:
      "Internet of Things (IoT) Development Competition merupakan kompetisi pengembangan perangkat berbasis IoT. Inovasi-inovasi dari kompetisi IoT Technocorner 2022 diharapkan akan aplikatif dan bermanfaat. Subtema yang diangkat dalam lomba IoT Technocorner 2022 meliputi Home Application, Kebutuhan Medis, Pendidikan, otomotif, transportasi, Agrikultur, Lingkungan, Fasilitas Publik , dan renewable energy.",
    logo: "/images/Homepage/iot.webp",
    champ: [
      {
        name: "Gold Cup",
        image: "/images/Competitions/gold-cup.svg",
        reward: "Rp 3.000.000,00",
      },
      {
        name: "Silver Cup",
        image: "/images/Competitions/silver-cup.svg",
        reward: "Rp 2.000.000,00",
      },
      {
        name: "Bronze Cup",
        image: "/images/Competitions/bronze-cup.svg",
        reward: "Rp 1.000.000,00",
      },
    ],
  },
  {
    id: "EEC",
    name: "eec",
    title: "Electrical Engineering Competition",
    content:
      "Internet of Things (IoT) Development Competition merupakan kompetisi pengembangan perangkat berbasis IoT. Inovasi-inovasi dari kompetisi IoT Technocorner 2022 diharapkan akan aplikatif dan bermanfaat. Subtema yang diangkat dalam lomba IoT Technocorner 2022 meliputi Home Application, Kebutuhan Medis, Pendidikan, otomotif, transportasi, Agrikultur, Lingkungan, Fasilitas Publik , dan renewable energy.",
    logo: "/images/Homepage/eec.webp",
    champ: [
      {
        name: "Gold Cup",
        image: "/images/Competitions/gold-cup.svg",
        reward: "Rp 3.000.000,00",
      },
      {
        name: "Silver Cup",
        image: "/images/Competitions/silver-cup.svg",
        reward: "Rp 2.000.000,00",
      },
      {
        name: "Bronze Cup",
        image: "/images/Competitions/bronze-cup.svg",
        reward: "Rp 1.000.000,00",
      },
    ],
  },
  {
    id: "TP",
    name: "transporter",
    title: "Transporter Competition",
    content:
      "Internet of Things (IoT) Development Competition merupakan kompetisi pengembangan perangkat berbasis IoT. Inovasi-inovasi dari kompetisi IoT Technocorner 2022 diharapkan akan aplikatif dan bermanfaat. Subtema yang diangkat dalam lomba IoT Technocorner 2022 meliputi Home Application, Kebutuhan Medis, Pendidikan, otomotif, transportasi, Agrikultur, Lingkungan, Fasilitas Publik , dan renewable energy.",
    logo: "/images/Homepage/tp.webp",
    champ: [
      {
        name: "Gold Cup",
        image: "/images/Competitions/gold-cup.svg",
        reward: "Rp 4.500.000,00",
      },
      {
        name: "Silver Cup",
        image: "/images/Competitions/silver-cup.svg",
        reward: "Rp 2.500.000,00",
      },
      {
        name: "Bronze Cup",
        image: "/images/Competitions/bronze-cup.svg",
        reward: "Rp 1.000.000,00",
      },
    ],
  },
  {
    id: "LF",
    name: "linefollower",
    title: "Line Follower Competition",
    content:
      "Internet of Things (IoT) Development Competition merupakan kompetisi pengembangan perangkat berbasis IoT. Inovasi-inovasi dari kompetisi IoT Technocorner 2022 diharapkan akan aplikatif dan bermanfaat. Subtema yang diangkat dalam lomba IoT Technocorner 2022 meliputi Home Application, Kebutuhan Medis, Pendidikan, otomotif, transportasi, Agrikultur, Lingkungan, Fasilitas Publik , dan renewable energy.",
    logo: "/images/Homepage/lf.webp",
    champ: [
      {
        name: "Gold Cup",
        image: "/images/Competitions/gold-cup.svg",
        reward: "Rp 4.500.000,00",
      },
      {
        name: "Silver Cup",
        image: "/images/Competitions/silver-cup.svg",
        reward: "Rp 2.500.000,00",
      },
      {
        name: "Bronze Cup",
        image: "/images/Competitions/bronze-cup.svg",
        reward: "Rp 1.000.000,00",
      },
    ],
  },
];
export { dataKompetisi };
